import usePropertyGroups from './usePropertyGroups';

export default usePropertyGroups;
